export function normalizeMathFieldLatex(rawLatex: string): string {
  return rawLatex
    // Prefer canonical inequality commands used across the codebase
    // Convert \ge/\le when they are standalone commands, but avoid mutating
    // longer commands such as \left.
    .replace(/\\ge(?![A-Za-z])/g, '\\geq')
    .replace(/\\le(?![A-Za-z])/g, '\\leq')
    // Keep fraction command consistent
    .replace(/\\dfrac/g, '\\frac')
    // Normalize minus sign from unicode input methods
    .replace(/\u2212/g, '-')
    // Collapse accidental extra spaces
    .replace(/\s+/g, ' ')
    .trim();
}
